import MagicLinkToken from 'features/auth/components/MagicLinkToken/MagicLinkToken';
import React from 'react';

export default function Page() {
  return <MagicLinkToken />;
}
